import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskLiveChatTeamChatsRoute: InvariantJiraRoute = {
	name: 'servicedesk-live-chat-team-chats',
	path: '/jira/servicedesk/projects/:projectKey/live-chat/team-chats',
	exact: true,
};
